"use client"

import { useQuery } from "@tanstack/react-query"
import {
  listToolInstructionVersionsAction,
  type ToolInstructionVersionView,
} from "@/server-actions/tool-instruction-versions"

/** A per-agent override, or `null` for the tenant-wide default. */
export type ToolInstructionScopeType = "message_agent" | "email_agent" | "voice_agent"

export const toolInstructionVersionsQueryKey = (
  toolName: string,
  scopeType: ToolInstructionScopeType | null,
  scopeId: string | null,
) => ["tool-instruction-versions", toolName, scopeType, scopeId] as const

export function useToolInstructionVersionsQuery(
  toolName: string,
  scopeType: ToolInstructionScopeType | null,
  scopeId: string | null,
  enabled: boolean,
) {
  return useQuery<ToolInstructionVersionView[]>({
    queryKey: toolInstructionVersionsQueryKey(toolName, scopeType, scopeId),
    enabled: enabled && Boolean(toolName),
    // The instructions are saved through fetchWithAuth, outside React Query, so the global
    // 60s staleTime would show a list missing the version just recorded — the one moment
    // users open this dialog.
    staleTime: 0,
    refetchOnMount: "always",
    queryFn: async () => {
      const result = await listToolInstructionVersionsAction(
        scopeType && scopeId
          ? { tool_name: toolName, scope_type: scopeType, scope_id: scopeId }
          : { tool_name: toolName },
      )
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
